import { derived, writable } from 'svelte/store';

// detecting dev environment
let is_dev = false;
if (window.location.host === 'localhost:5000') {
  is_dev = true;
}
export const dev = is_dev;

// auth0 integration
export const auth_client = writable('');
export const auth_logged_in = writable(false);
export const auth_user = writable('');

// leaflet integration
export const leaflet_layers = writable({});
export const leaflet_map = writable('');

// bookmark toolbar
export const bookmarks = writable({});
export const bookmark_selected = writable('');

// lang
export const lang = writable('lv');

// profile toolbar
export const prof_edit = writable({});
export const prof_edit_mode = writable(false);

// layers toolbar
export const layer_selected = writable('');
export const layers_visible = writable({});

// navigation toolbar
export const panel_selected = writable('');

// plots toolbar
export const plots = writable({});
export const plot_creation_mode = writable(false);
export const plot_selected = writable('');
export const plot_page = writable(0);

// upload file
export const upload_status_code = writable('');
export const upload_status_text = writable('');
